/*
  Snowleap: kleur eerst bij producten met ontbrekende combinaties (thema Vision).
  Voorbeeld: Wit in 10 maten en Taupe in 1 maat. Met dit script staat Kleur bovenaan, is een kleur altijd
  klikbaar, toont Maat alleen de maten van de gekozen kleur, en komt de klant nooit op een niet-bestaande
  combinatie uit. Producten waarvan elke combinatie bestaat blijven precies zoals het thema ze toont.
  Uitzetten: verwijder de regel met snowleap-color-first.js uit layout/theme.liquid.
*/
(function () {
  if (window.__snowleapColorFirst) return;
  window.__snowleapColorFirst = true;

  var COLOUR = /kleur|color|colour|couleur/i;

  function controlOf(group) { return group.querySelector('select') || group.querySelector('input'); }
  function choices(group) {
    var select = group.querySelector('select');
    return Array.prototype.slice.call(select ? select.options : group.querySelectorAll('input'));
  }
  function selected(group) {
    var select = group.querySelector('select');
    if (select) return select.value;
    var input = group.querySelector('input:checked');
    return input ? input.value : null;
  }
  function select(group, value) {
    var control = group.querySelector('select');
    if (control) { control.value = value; return; }
    choices(group).forEach(function (input) { if (input.value === value) input.checked = true; });
  }
  function optionName(group) {
    var control = controlOf(group);
    return control ? String(control.name || '') : '';
  }

  function context(el) {
    if (!el.getVariantData) return null;
    var groups = Array.prototype.slice.call(el.querySelectorAll('fieldset'));
    var colour = groups.filter(function (g) { return COLOUR.test(optionName(g)); })[0];
    if (!colour || groups.length < 2) return null;
    var variants = el.getVariantData() || [];
    var combinations = groups.reduce(function (n, g) { return n * choices(g).length; }, 1);
    if (variants.length >= combinations) return null;
    return {
      groups: groups,
      colour: colour,
      others: groups.filter(function (g) { return g !== colour; }),
      variants: variants,
      keyOf: function (g) { return 'option' + (groups.indexOf(g) + 1); },
    };
  }

  function setState(el, choice, state) {
    if (choice.tagName === 'OPTION') {
      choice.hidden = state === 'hidden';
      choice.disabled = state === 'hidden';
      return;
    }
    var label = el.querySelector('label[for="' + CSS.escape(choice.id) + '"]');
    if (label) label.style.display = state === 'hidden' ? 'none' : '';
    choice.disabled = state === 'hidden';
    choice.classList.toggle('is-disabled', state === 'soldout');
  }

  function apply(el) {
    var ctx = context(el);
    if (!ctx) return;
    var wrapper = ctx.colour.parentElement;
    if (wrapper) {
      wrapper.style.display = 'flex';
      wrapper.style.flexDirection = 'column';
    }
    ctx.colour.style.order = '-1';

    var colourKey = ctx.keyOf(ctx.colour);
    choices(ctx.colour).forEach(function (choice) {
      var matches = ctx.variants.filter(function (v) { return v[colourKey] === choice.value; });
      setState(el, choice, matches.some(function (v) { return v.available; }) ? 'available' : (matches.length ? 'soldout' : 'hidden'));
    });

    var chosen = selected(ctx.colour);
    var pool = ctx.variants.filter(function (v) { return v[colourKey] === chosen; });
    ctx.others.forEach(function (group) {
      var key = ctx.keyOf(group);
      choices(group).forEach(function (choice) {
        var matches = pool.filter(function (v) { return v[key] === choice.value; });
        setState(el, choice, matches.some(function (v) { return v.available; }) ? 'available' : (matches.length ? 'soldout' : 'hidden'));
      });
      var current = selected(group);
      pool = pool.filter(function (v) { return v[key] === current; });
    });
  }

  // Loopt vóór de eigen change-afhandeling van het thema, dat daarna een bestaande variant ziet.
  document.addEventListener('change', function (event) {
    var control = event.target;
    var el = control && control.closest && control.closest('variant-selects, variant-radios');
    if (!el) return;
    var ctx = context(el);
    if (!ctx || control.closest('fieldset') !== ctx.colour) return;
    var colourKey = ctx.keyOf(ctx.colour);
    var options = ctx.variants.filter(function (v) { return v[colourKey] === control.value; });
    var sameOthers = function (v) { return ctx.others.every(function (g) { return v[ctx.keyOf(g)] === selected(g); }); };
    var target = options.filter(function (v) { return v.available && sameOthers(v); })[0]
      || options.filter(function (v) { return v.available; })[0]
      || options.filter(sameOthers)[0]
      || options[0];
    if (!target) return;
    ctx.others.forEach(function (group) { select(group, target[ctx.keyOf(group)]); });
  }, true);

  function start() {
    var Selects = customElements.get('variant-selects');
    var original = Selects.prototype.setDisabled;
    Selects.prototype.setDisabled = function () {
      var result = original.apply(this, arguments);
      apply(this);
      return result;
    };
    document.querySelectorAll('variant-selects, variant-radios').forEach(apply);
  }

  customElements.whenDefined('variant-selects').then(start);
})();
